import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const OfferOne = () => {
    const [offers, setOffers] = useState([]);

    useEffect(() => {
        const fetchOffer = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/offers/offerOne`);
                if (res.data && Array.isArray(res.data)) {
                    const activeOffers = res.data.filter((b) => b.status);
                    const assigned = [
                        activeOffers[0],
                        activeOffers[1],
                    ].filter(Boolean);
                    setOffers(assigned);
                }
            } catch (err) {
                console.error("Error fetching OfferOne section offers:", err);
            }
        };
        fetchOffer();
    }, []);

    return (
        <>
            <style>{`
            @media (max-width: 400px) {
                .offer-card__thumb {
                    width: 35% !important;
                    height: 100px !important;
                }
            }

        `}</style>
            <section className="offer pt-80 pb-80">
                <div className="container container-lg">
                    <div className="row gy-4">
                        {offers.map((offer, index) => {
                            return (
                                <div className="col-sm-6" key={index}>
                                    <div className="offer-card d-flex align-items-center gap-16 position-relative rounded-16 bg-main-600 overflow-hidden p-16 z-1">
                                        <img
                                            src="assets/images/shape/offer-shape.png"
                                            alt=""
                                            className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                                        />
                                        <div className="offer-card__thumb d-block"
                                            style={{
                                                width: "100%",
                                                maxWidth: "400px",
                                                height: window.innerWidth < 576 ? "160px" : "250px",
                                                overflow: "hidden",
                                                borderRadius: "12px",
                                            }}
                                        >
                                            <img src={offer.image} alt="Main Img"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        </div>
                                        <div className="py-xl-4">
                                            <div className="offer-card__logo mb-16 w-80 h-80 flex-center bg-white rounded-circle d-none d-md-flex">
                                                <img src={offer.logo} alt="Logo Img" />
                                            </div>
                                            <h4 className="text-white mb-8"> {offer.title} </h4>
                                            <div className="flex-align gap-8">
                                                <span className="text-sm text-gray-900">{offer.subTitle}</span>
                                            </div>
                                            <Link
                                                to={offer.link || "/shop"}
                                                className="mt-16 btn bg-white hover-text-white hover-bg-main-800 text-heading fw-medium d-inline-flex align-items-center rounded-pill gap-8"
                                                tabIndex={0}
                                            >
                                                Shop Now
                                                <span className="icon text-xl d-flex">
                                                    <i className="ph ph-arrow-right" />
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </>
    )
}

export default OfferOne


// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";

// const OfferOne = () => {
//   const [offers, setOffers] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchOffer = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/offers/offerOne`
//         );

//         if (Array.isArray(res.data)) {
//           const activeOffers = res.data.filter((b) => b.status);
//           setOffers([activeOffers[0], activeOffers[1]].filter(Boolean));
//         }
//       } catch (err) {
//         console.error("Error fetching OfferOne offers:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchOffer();
//   }, []);

//   return (
//     <>
//       <style>{`
//         /* ================= OFFER SECTION ================= */

//         .offer {
//           padding: 80px 0;
//         }

//         .offer-card {
//           min-height: 280px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: transform 0.3s ease;
//         }

//         .offer-card:hover {
//           transform: translateY(-5px);
//         }

//         .offer-card__thumb {
//           justify-content: center;
//           width: 400px;
//           height: 250px;
//           overflow: hidden;
//           border-radius: 12px;
//           flex-shrink: 0;
//         }

//         .offer-card__thumb img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .offer-card__logo {
//           width: 80px;
//           height: 80px;
//           padding: 12px;
//         }

//         .offer-card__logo img {
//           max-width: 100%;
//           max-height: 100%;
//           object-fit: contain;
//         }

//         .offer-content {
//           flex: 1;
//           padding: 20px 0;
//         }

//         /* ================= TABLET ================= */
//         @media (max-width: 991px) {
//           .offer {
//             padding: 60px 0;
//           }

//           .offer-card {
//             flex-direction: column;
//             text-align: center;
//             padding: 24px !important;
//           }

//           .offer-card__thumb {
//             width: 100% !important;
//             height: 200px !important;
//             margin-bottom: 20px;
//           }

//           .offer-card__logo {
//             margin: 0 auto 16px;
//           }

//           .offer-content {
//             padding: 0;
//           }
//         }

//         /* ================= MOBILE ================= */
//         @media (max-width: 575px) {
//           .offer {
//             padding: 40px 0;
//           }

//           .offer-card {
//             padding: 16px !important;
//             min-height: auto;
//             flex-direction: column;
//             text-align: center;
//           }

//           /* Center + resize image */
//           .offer-card__thumb {
//             height: 150px !important;
//             width: 90% !important;
//             margin: 0 auto 16px auto;
//             border-radius: 10px;
//           }

//           /* Hide logo on mobile */
//           .offer-card__logo {
//             display: none !important;
//           }

//           .offer-card h4 {
//             font-size: 1.1rem;
//             margin-bottom: 6px !important;
//           }

//           .offer-card .text-sm {
//             font-size: 0.85rem;
//             margin-bottom: 8px;
//             display: block;
//           }

//           .offer-card .btn {
//             font-size: 0.9rem;
//             padding: 8px 22px;
//             margin-top: 12px !important;
//           }

//           .col-sm-6 + .col-sm-6 {
//             margin-top: 16px;
//           }
//         }

//         /* ================= SMALL MOBILE ================= */
//         @media (max-width: 400px) {
//           .offer-card__thumb {
//             height: 135px !important;
//             width: 100% !important;
//           }

//           .offer-card h4 {
//             font-size: 1rem;
//           }
//         }

//         /* Loading */
//         .offer-loading {
//           text-align: center;
//           padding: 60px 20px;
//           color: #666;
//         }
//       `}</style>

//       <section className="offer">
//         <div className="container container-lg">
//           {loading ? (
//             <div className="offer-loading">Loading offers...</div>
//           ) : offers.length > 0 ? (
//             <div className="row gy-4">
//               {offers.map((offer, index) => (
//                 <div className="col-sm-6" key={index}>
//                   <div className="offer-card rounded-16 bg-main-600 overflow-hidden p-16 flex-align gap-16 flex-wrap position-relative z-1">
//                     <img
//                       src="assets/images/shape/offer-shape.png"
//                       alt=""
//                       className="position-absolute inset-0 z-n1 w-100 h-100 opacity-6"
//                     />

//                     <div className="offer-card__thumb">
//                       <img
//                         src={offer.image}
//                         alt={offer.title}
//                         loading={index === 0 ? "eager" : "lazy"}
//                       />
//                     </div>

//                     <div className="offer-content">
//                       <div className="offer-card__logo mb-16 flex-center bg-white rounded-circle">
//                         <img src={offer.logo} alt="Logo" />
//                       </div>

//                       <h4 className="text-white">{offer.title}</h4>

//                       <span className="text-sm text-main-two-600">
//                         {offer.subTitle}
//                       </span>

//                       <Link
//                         to={offer.link || "/shop"}
//                         className="mt-16 btn bg-white hover-bg-main-800 hover-text-white text-heading fw-medium rounded-pill d-inline-flex align-items-center gap-8"
//                       >
//                         Shop Now
//                         <i className="ph ph-arrow-right text-xl" />
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="offer-loading">No offers available.</div>
//           )}
//         </div>
//       </section>
//     </>
//   );
// };

// export default OfferOne;